import "../styles/vars.scss";
import SvgIcn from "../data/IconCompo";
import LogoP from "../ui/atoms/LogoP";
import ItemsCard from "../ui/compoP/ItemCard";
import TagButtonZ from "../ui/atoms/TagButtonZ";
import Inputz from "../ui/atoms/Inputz";


function Compoz() {

  return (
    <div className="ds-hero">
      <h4> COMPONENTS <br /> 11/11/2024 <SvgIcn name="cal" /> </h4>

      {/* - - - - - - - - - LOGO - - - - - - - - - */}
      <div className="ds-box">
        <h2>LOGO</h2>
        <LogoP logo="logo01" hoverLogo="logo03" logoTypeEn="logotype_en" logoTypeJp="logotype_jp" style={{ width: "80px" }} />
        <LogoP logo="logo01" hoverLogo="logo03" style={{ width: "100px" }} />
        <LogoP logo="logo01" hoverLogo="logo03" logoTypeEn="logotype_en" logoTypeJp="logotype_jp" style={{ width: "44px" }} />
        <LogoP logoTypeEn="logotype_en" logoTypeJp="logotype_jp" style={{ width: "120px" }} />
      </div>
      {/* - - - - - - - - - Items Cards - - - - - - - - - */}
      <div className="ds-box">
        <h2>ITEMS CARDS</h2>
        <ItemsCard icon="tool" title="Tools" text="UXUI Tools" to="/home" color="tools" />
      </div>
      {/* - - - - - - - - - Tags - - - - - - - - - */}
      <div className="ds-box">
        <h2>ITEMS CARDS</h2>
        <div className="tags-box">
          <Inputz
          placeholder="Search"
          iconL="search"
          focusL="search"
          />  
        <TagButtonZ 
        label="ALL" 
        iconL={"cal"} 
        counter={130}       
        />
        <TagButtonZ 
        label="Favs" 
        iconL={"heart"} 
        counter={31}       
        />
        <TagButtonZ label="UX Design" />
        <TagButtonZ label="UX Design" />
          <TagButtonZ label="UI Design" />
          <TagButtonZ label="Image" />
          <TagButtonZ label="Video" />
          <TagButtonZ label="Audio" />
          <TagButtonZ label="Animation" />
          <TagButtonZ label="Color" />
          <TagButtonZ label="Font" />
          <TagButtonZ label="No Code" />
          <TagButtonZ label="Productivity" />
          <TagButtonZ label="Others" />

        </div>
      </div>
      {/* - - - - - - - - - - - - - - - - - - - - - - */}
    </div>

  );
}

export default Compoz;
